import { v4 } from 'uuid';

export const uuidv4 = v4;
